/* ================================================== */
/* HEADER
/* ================================================== */

$(document).ready(function() {
	var $header = $('.section-header, .article-header');

	if ($header.length) {
		var tl = gsap.timeline();

		tl.to($('[data-reveal-header="cover"]', $header), 0.75, { opacity: 1, x: 0, y: 0 })
			.to($('[data-reveal-header="text"]', $header), 0.5, { opacity: 1, x: 0, y: 0 });

		if ($header.is('.section-header')) {
			tl.to($('[data-reveal-header="icon"]', $header), 0.5, { opacity: 1, x: 0, y: 0 })
				.to($('[data-reveal-header="scroll-to"]', $header), 1, { opacity: 1, delay: 0.75 })
		}

		ScrollTrigger.create({
			trigger: $header,
			once: true,
			animation: tl,
			toggleActions: 'play',
			// markers: true
		});
	}
});